import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, useRouterHistory } from 'react-router';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import { syncHistoryWithStore } from 'react-router-redux';
import { parse, stringify } from 'qs';
// eslint-disable-next-line @emotion/no-vanilla
import { cache } from 'emotion';
import { CacheProvider } from '@emotion/core';
import { UserContextProvider } from '@ordermentum/ui-shared/utilities/UserContextProvider';
import { ThemeContext } from '@ordermentum/ui-shared/utilities/theme';
import store from './redux/store';
import routes from './routes';
import '@ordermentum/ui-shared/middleware/user_context';

// eslint-disable-next-line react-hooks/rules-of-hooks
const createAppHistory = useRouterHistory(createBrowserHistory);
const appHistory = createAppHistory({
  parseQueryString: parse,
  stringifyQuery: stringify,
});
const history = syncHistoryWithStore(appHistory, store);

const renderNode = document.getElementById('root');
if (renderNode) {
  ReactDOM.render(
    <CacheProvider value={cache}>
      <Provider store={store}>
        <ThemeContext.Provider value="futuro">
          <UserContextProvider>
            <Router history={history} routes={routes} />
          </UserContextProvider>
        </ThemeContext.Provider>
      </Provider>
    </CacheProvider>,
    renderNode
  );
}
